import React, { useState } from "react";
import cx from "classnames";
import styles from "../../scss/components/DapWarningDialog.module.scss";
import LModal from "../../../common/components/Modals/LModal/LModal";
import Checkbox from "../../../common/components/Forms/Checkbox/Checkbox";
import Button from "../../../common/components/Forms/Button/Button";
import { quoteModifiedWarning } from "../../api/ApiDigitalAdvice";
import useErrorLogger from "../../../common/hooks/useErrorLogger";

interface IDapWarningDialog {
    isOpen: boolean;
    onClose: (isContinue: boolean) => void;
}

const DapWarningDialog: React.FC<IDapWarningDialog> = (props) => {
    const { isOpen, onClose } = props;
    const [hasAcceptedDisclaimer, setHasAcceptedDisclaimer] = useState(false);
    const sessionUserId = JSON.parse(window.localStorage.getItem("dap_states"))
        ?.sessionUserId;

    return (
        <LModal
            Header={() => null}
            calcHeightMode="auto"
            width="narrow"
            removePadding={true}
            isOpen={isOpen}
            onClose={() => onClose(false)}>
            {() => {
                return (
                    <div className={cx(styles["dap-warning-dialog-modal"])}>
                        <div className={styles["dap-warning__header"]}>
                            <h2>Please note</h2>
                        </div>
                        <div className={styles["dap-warning__content"]}>
                            <p className={styles["dap-warning__desc"]}>
                                If you edit the recommended cover we've provided,
                                LifeDirect cannot say the changes will still fit your
                                personal situation. You are welcome to make changes, but
                                doing so will void the current recommendation.
                            </p>
                            <p className={styles["dap-warning__note"]}>
                                If you would like to make changes or need some help,
                                please{" "}
                                <a href="/our-service/contact-us.aspx" target="_blank">
                                    contact our team
                                </a>{" "}
                                for a personalised advice discussion.
                            </p>
                            <Checkbox
                                name="disclaimer-acceptance"
                                size="l"
                                className="gap-xl"
                                checked={hasAcceptedDisclaimer}
                                onChange={(e) =>
                                    setHasAcceptedDisclaimer(e.target.checked)
                                }
                                label={
                                    <span className={cx("label-l space-pre-m")}>
                                        I have read and understand the{" "}
                                        <a
                                            href="/our-service/important-information.aspx"
                                            target="_blank">
                                            disclosure document
                                        </a>
                                    </span>
                                }
                            />

                            <Button
                                className={styles["dap-warning__continue"]}
                                width="fill"
                                component="button"
                                size="s"
                                onClick={() => {
                                    window.localStorage.setItem(
                                        "quote-modified-warning",
                                        "1"
                                    );
                                    quoteModifiedWarning(sessionUserId)
                                        .then(() => {
                                            onClose(true);
                                        })
                                        .catch(() => {
                                            useErrorLogger();
                                        });
                                }}
                                isDisabled={!hasAcceptedDisclaimer}
                                variant="calltoaction">
                                <span>Continue</span>
                            </Button>

                            <Button
                                className={styles["dap-warning__cancel"]}
                                width="fill"
                                component="p"
                                size="s"
                                onClick={() => onClose(false)}
                                variant="default">
                                <span>Cancel</span>
                            </Button>
                        </div>
                    </div>
                );
            }}
        </LModal>
    );
};

export default DapWarningDialog;
